/* Actions */
import { baseActionName } from "./actions";

/* Utils */
import { makeFetchReducers, SECTIONS_URIS } from "../../utils";

const customReset = (state) =>
  state.map((section) => {
    if (
      section.id === SECTIONS_URIS.CONTINUE_WATCHING ||
      section.id === SECTIONS_URIS.CONTINUE_WATCHING_LIVE ||
      section.id === SECTIONS_URIS.MY_LIST
    )
      return { ...section, items: null };

    return section;
  });

export default makeFetchReducers(baseActionName, [], { customReset });
